import React, { useEffect, useState } from "react";
import { Card, Col, Row, Button, Form, Container } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import { useSupplierStore } from '../../hooks/Mantenimiento_Generales/useSupplierStore';


export default function Standard() {
  const [formData, setFormData] = useState({
    id: 0,
    name: '',
    description: '',
    status: 1
  });

  const { Upsert } = useSupplierStore();


  const location = useLocation();
  const supplierData = location.state ? location.state.supplierData[0] || {} : {};

  useEffect(() => {
    if (Object.keys(supplierData).length > 0) {
      setFormData({
        id: supplierData.id || 0,
        name: supplierData.name || '',
        description: supplierData.description || '',
        status: supplierData.status || 1,
      });
    }
  }, [supplierData]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    Upsert({ id: formData.id, name: formData.name, description: formData.description, status: formData.status });
    // Aquí puedes enviar formData a donde lo necesites
    console.log(formData);
  };

  return (
    <React.Fragment>
      <Container fluid="md">
        <div className="main-app mt-0 p-lg-4">
          <div className="d-md-flex align-items-center justify-content-between mb-4">
            <div>
              <h4 className="main-title mb-0">Proveedores</h4>
            </div>
          </div>
          <Card.Body>
            <Form onSubmit={handleFormSubmit}>
              <Row className="g-12">
                <Form.Control type="hidden" name="id" value={formData.id} onChange={handleInputChange} disabled required />
                <Form.Group as={Col}>
                  <Form.Label htmlFor="name">Nombre</Form.Label>
                  <Form.Control type="text" placeholder="Nombre" name="name" value={formData.name} onChange={handleInputChange} required />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label htmlFor="description">Descripcion</Form.Label>
                  <Form.Control type="text" placeholder="Descripcion" name="description" value={formData.description} onChange={handleInputChange} required />
                </Form.Group>
                <Form.Group as={Col}>
                  <div className="mb-4">
                    <Form.Label>Estado</Form.Label>
                    <Form.Select name="status" value={formData.status} onChange={handleInputChange} aria-label="Default select example" >
                      <option>Select</option>
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </Form.Select>
                  </div>
                </Form.Group>
              </Row>
              <hr />
              <div>
                <Col sm="12">
                  <Button type="submit" variant="success" className="btn-sign">Guardar</Button>
                  <Button type="submit" variant="danger" as={Link} to="/pages/supplier" className="btn-sign">Cancelar</Button>
                </Col>
              </div>
            </Form>
          </Card.Body>
        </div>
      </Container>
    </React.Fragment>
  );
}
